var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      [
        _c("SectionHeader", {
          attrs: { title: "Client Services", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _vm.allServices.length > 0
              ? _c(
                  "div",
                  { staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4" },
                  [
                    _c("div", [
                      _c(
                        "ul",
                        { staticClass: "space-y-2 text-gray-600" },
                        _vm._l(
                          _vm.firstColumnServices,
                          function (service, index) {
                            return _c("li", { key: index }, [
                              _vm._v(" " + _vm._s(service) + " "),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "ul",
                        { staticClass: "space-y-2 text-gray-600" },
                        _vm._l(
                          _vm.secondColumnServices,
                          function (service, index) {
                            return _c("li", { key: index }, [
                              _vm._v(" " + _vm._s(service) + " "),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                )
              : _c("div", { staticClass: "text-gray-600" }, [_vm._v("N/A")]),
            _c("InfoField", {
              staticClass: "pt-6",
              attrs: {
                label: "General Notes",
                value: _vm.data.client_services_gen_notes,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }